<div class="mobile-lcl-card">
  <div class="mobile-lcl-card__header">
    <div class="mobile-lcl-card__header-reference">
      <span class="label">{{ "LABELS.SHIPMENT" | translate }}</span>
      <span class="value">{{ info?.referenceNumber }}</span>
    </div>
    <div
      class="mobile-lcl-card__header-tracking"
      *ngIf="isShipment"
      [ngClass]="{
        unfilled:
          info?.trackingState !== enumLclTrackingStates.BOOKING_PLACED &&
          info?.trackingState !== enumLclTrackingStates.DELIVERED &&
          info?.state !== enumShipmentState.CANCELED,
        canceled: info?.state === enumShipmentState.CANCELED
      }"
    >
      <i
        class="fa fa-check"
        *ngIf="
          info?.trackingState !== enumLclTrackingStates.BOOKING_PLACED &&
          info?.trackingState !== enumLclTrackingStates.DELIVERED &&
          info.state !== enumShipmentState.CANCELED
        "
      ></i>
      {{
        (info.state !== enumShipmentState.CANCELED
          ? "LCL_TRACKING_STATE." + enumLclTrackingStates[info?.trackingState]
          : "STATUS_MANUAL.CANCELED"
        ) | translate
      }}
    </div>
  </div>
  <div class="mobile-lcl-card__route">
    <div class="route-item">
      <div class="circle" [ngClass]="{ 'circle-active': info?.trackingState >= enumLclTrackingStates.AT_ORIGIN_WAREHOUSE }"></div>
      <div class="departure-line" [ngClass]="{ 'departure-line-active': info?.trackingState >= enumLclTrackingStates.IN_TRANSIT }"></div>
      <span>
        <strong>{{ info?.voyage?.route?.departurePort?.displayName }}</strong>
        ({{ info?.voyage?.route?.departurePort?.unCode }}),
        {{ info?.voyage?.route?.departurePort?.country?.description }}
      </span>
    </div>
    <div class="route-item">
      <div class="circle" [ngClass]="{ 'circle-active': info?.trackingState >= enumLclTrackingStates.DELIVERED }"></div>
      <div
        class="arrival-line"
        [ngClass]="{ 'arrival-line-active': info?.trackingState >= enumLclTrackingStates.AT_DESTINATION_WAREHOUSE }"
      ></div>
      <span>
        <strong>{{ info?.voyage?.route?.arrivalPort?.displayName }}</strong>
        ({{ info?.voyage?.route?.arrivalPort?.unCode }}),
        {{ info?.voyage?.route?.arrivalPort?.country?.description }}
      </span>
    </div>
  </div>

  <div class="mobile-lcl-card__packages" [ngStyle]="{ paddingBottom: !isShipment ? '10px' : 0 }">
    <ng-container [ngTemplateOutlet]="shipmentTotals" *ngIf="isShipment"></ng-container>

    <ng-container [ngTemplateOutlet]="quoteTotals" *ngIf="!isShipment"></ng-container>
  </div>

  <div *ngIf="!isShipment" class="mobile-lcl-card__booking">
    <div class="mobile-lcl-card__booking-header">
      <span class="label">{{ "LABELS.CURRENT_TOTAL_COST" | translate }}:</span>
      <span class="value">{{ info?.aggregatedStatistics?.totalPrice | currency : "USD" : "symbol" : "1.2-2" }}</span>
    </div>
    <div class="mobile-lcl-card__booking-button" (click)="bookQuote()">
      <span>{{ "BUTTON.BOOK_NOW" | translate }}</span>
    </div>
  </div>
</div>

<ng-template #quoteTotals>
  <div class="d-flex align-items-center justify-content-between">
    <div class="info-block">
      <span class="label">{{ "UNITS" | translate }}:</span>
      <span class="value">{{ info?.aggregatedStatistics?.totalPackages }}</span>
    </div>
    <div class="info-block">
      <span class="label">{{ "LABELS.WEIGHT" | translate }}</span>
      <span class="value">
        {{ info?.aggregatedStatistics?.realMeasurements?.totalWeight * KG_TON_MULTIPLIER }} {{ "WEIGHT_UNIT.KG" | translate }}
      </span>
    </div>
    <div class="info-block">
      <span class="label">{{ "LABELS.VOLUME" | translate }}:</span>
      <span class="value">{{ info?.aggregatedStatistics?.realMeasurements?.totalVolume }} {{ "LABELS.CBM" | translate }}</span>
    </div>
  </div>
</ng-template>

<ng-template #shipmentTotals>
  <div class="info-block">
    <span class="label">{{ "LABELS.PACKAGES" | translate }}:</span>
    <span class="value">{{ info?.aggregatedStatistics?.totalPackages }}</span>
  </div>
  <div class="info-block">
    <span class="label">{{ "LABELS.WEIGHT_TON" | translate }}:</span>
    <span class="value">{{ info?.aggregatedStatistics?.realMeasurements?.totalWeight }}</span>
  </div>
  <div class="info-block">
    <span class="label">{{ "LABELS.VOLUME_CBM" | translate }}:</span>
    <span class="value">{{ info?.aggregatedStatistics?.realMeasurements?.totalVolume }}</span>
  </div>
  <div class="info-block" *ngIf="isShipment">
    <span class="label">{{ "LABELS.INCOTERMS" | translate }}:</span>
    <span class="value">{{ "LABELS." + enumIncotermsType[info?.incoTermsType] + "_LABEL" | translate }}</span>
    <img
      src="assets/icons/edit_gray.svg"
      *ngIf="info?.state !== enumShipmentState.CANCELED && info?.trackingState < enumLclTrackingStates.AT_ORIGIN_WAREHOUSE"
      (click)="onEditIncoTerms()"
    />
  </div>
</ng-template>
